/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';

export default AreaComponent =>
  class ADVRouter extends React.Component {
    constructor(props) {
      super(props);

      this.handleReactRoute = this.handleRouteChange.bind(this);
      this.handleHMRoute = this.handleRouteChange.bind(this);
    }

    componentDidMount() {
      document.addEventListener('reactroute', this.handleReactRoute);
      document.addEventListener('hmroute', this.handleHMRoute);

      const { defaultController, defaultParams = {}, forceDefaultRoute } = this.props;

      const currentRouteInfo = ADV.util.Router.status();

      if (forceDefaultRoute || !currentRouteInfo) {
        return ADV.util.Router.go2(defaultController, defaultParams);
      }

      const { id, params, type, has_plan_selection, skipWrapper } = currentRouteInfo;

      return this.handleRouteChange({
        detail: {
          controller: id,
          params,
          show_plan_selector: has_plan_selection,
          skipWrapper,
          isReactRoute: type === 'React',
        },
      });
    }

    componentWillUnmount() {
      document.body.removeEventListener('reactroute', this.handleReactRoute);
      document.body.removeEventListener('hmroute', this.handleHMRoute);
    }

    handleRouteChange({
      detail: {
        isReactRoute,
        controller,
        params = {},
        show_plan_selector: shouldShowPlanSelector,
        skipWrapper,
      },
    }) {
      const pageName =
        controller === 'Profile'
          ? `${controller}${params.pageId.replace(
              /\w\S*/g,
              txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
            )}`
          : controller;

      this.props.setCurrentRoute({
        controller,
        params,
        shouldShowPlanSelector,
        skipWrapper,
        Component: null,
        isReactRoute,
        pageName,
      });
    }

    render() {
      const {
        currentRoute: { params, controller, isReactRoute, shouldShowPlanSelector, skipWrapper },
      } = this.props;

      return (
        controller && (
          <AreaComponent
            route={{
              controller,
              params,
              isReactRoute,
              shouldShowPlanSelector,
              skipWrapper,
            }}
          />
        )
      );
    }
  };
